import { BooleanInput, Edit, FunctionField, NumberInput, PasswordInput, SimpleForm, TextInput, email, required, useGetIdentity, useNotify, useRedirect, useTranslate } from 'react-admin'
import MailServiceConfigEditActions from './MailServiceConfigEditActions'
import Form from '../../inputFormComponents/Form'
import FormCard from '../../inputFormComponents/FormCard'
import FormRow from '../../inputFormComponents/FormRow'
import MailServiceConfigEditToolBar from './MailServiceConfigEditToolBar'
import { apiService } from '../../apiService'
import { ConfigureMailServiceCommand, UserReadModel } from '../../GeneratedClients/FreeBillApi'
import { useMutation } from "react-query";
import { useState } from 'react'
import { Button } from '@mui/material'
import DescriptionMailServer from './DescriptionMailServer'

const MailServiceConfigEdit = () => {

  const [showPassword, setShowPassword] = useState<boolean>(false)
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const { data: identity, isLoading } = useGetIdentity()
  const { mutate: configMailService, isLoading: isLoadingMailServiceConfig } = useMutation((command: ConfigureMailServiceCommand) => 
    apiService.UsersApi.configureMailService({configureMailServiceCommand: command, id: identity!.id.toString()})  
  )

  const handleSubmit = async(fieldValues: UserReadModel, id: string) => {
    const configureMailServiceCommand: ConfigureMailServiceCommand = {
      userId: id,
      mailServiceConfig: fieldValues.mailServiceConfig
    }
    configMailService(configureMailServiceCommand, {
      onSuccess(data) {
        notify(translate('ra.notification.updated', {smart_count: 1}))
        redirect(`/users/${id}/mailServiceConfig`)
      },
      onError(error: any) {
        notify(error, {type: 'error'})
      },
    })
  }

  const cards = [
    <FormCard 
      title={"Bestehende Email-Adresse einrichten"} 
      description={<DescriptionMailServer />}
      rows={[
        <FormRow fields={[
          <TextInput fullWidth helperText={"Deine bestehende E-Mail-Adresse zum Versenden."} source="mailServiceConfig.email" label="resources.mailServiceConfig.email" validate={[required(), email()]} />,
          <TextInput sx={{ml: 2}} fullWidth helperText={"Dein Name, wie er Rechnungsempfängern gezeigt wird."} source="mailServiceConfig.sender" label="resources.mailServiceConfig.sender" validate={required()} />,
        ]} />,
        <FormRow fields={[
          <TextInput fullWidth helperText={"Zugangsdaten für deine bestehende E-Mail-Adresse."} source="mailServiceConfig.username" label="resources.mailServiceConfig.userName" />,
          <FunctionField display={"flex"} width={"100%"} ml={2} render={(user: UserReadModel) => 
            !user.mailServiceConfig || showPassword
              ? <PasswordInput fullWidth helperText={false} source="mailServiceConfig.password" label="resources.mailServiceConfig.password" />
              : <Button sx={{my: 1}} onClick={() => setShowPassword(true)} size='small'>Passwort ändern</Button>
          } />  
        ]} />,
        <FormRow fields={[
          <TextInput fullWidth helperText={"Konfiguration des Postausgangs-Server"} source="mailServiceConfig.host" label="resources.mailServiceConfig.host" validate={required()} />,
          <NumberInput sx={{ml: 2}} fullWidth helperText={false} source="mailServiceConfig.port" label="resources.mailServiceConfig.port" validate={required()} />,
        ]} />,
        <FormRow fields={[
          <BooleanInput fullWidth helperText={false} source="mailServiceConfig.useSsl" label="resources.mailServiceConfig.useSsl" />
        ]} />
      ]}/>
  ]

  if(isLoading || !identity) return null

  return (
    <Edit actions={<MailServiceConfigEditActions />} resource='users' id={identity.id} title={translate("resources.mailServiceConfig.name", {smart_count: 1})}>
      <SimpleForm toolbar={<MailServiceConfigEditToolBar />} onSubmit={(e) => handleSubmit(e, identity.id.toString())}>
        <Form cards={cards} />
      </SimpleForm>
    </Edit>
  )
}

export default MailServiceConfigEdit